const productFields = `
  id
  tags
  title
  handle
  availableForSale
  images(first: 100) {
    edges {
      node {
        src
        altText
        height
        width
      }
    }
  }
  media(first: 100) {
    edges {
      node {
        alt
        mediaContentType
        ... on MediaImage {
          image {
            src
            altText
            height
            width
          }
        }
        ... on ExternalVideo {
          id
          host
          embeddedUrl
        }
        ... on Video {
          id
          sources {
            format
            height
            mimeType
            url
            width
          }
        }
        previewImage {
          id
          originalSrc
          transformedSrc
        }
      }
    }
  }
  onlineStoreUrl
  options {
    name
    values
    optionValues {
      name
      swatch {
        image {
          alt
          previewImage {
            url
          }
        }
        color
      }
    }
  }
  priceRange {
    minVariantPrice {
      amount
    }
    maxVariantPrice {
      amount
    }
  }
  compareAtPriceRange {
    maxVariantPrice {
      amount
    }
    minVariantPrice {
      amount
    }
  }
  compatibleSizes: metafield(namespace: "bundle", key: "compatible_sizes") {
    reference {
      ... on Metaobject {
        id
        models: field(key: "models") {
          value
        }
        sizes: field(key: "sizes") {
          value
        }
      }
    }
  }
  coverImage: metafield(namespace: "custom", key: "cover_image") {
    reference {
      ... on MediaImage {
        image {
          altText
          src
        }
      }
    }
  }
  bundleProducts: metafield(namespace: "bundle", key: "products") {
    key
    value
    references(first: 50) {
      edges {
        node {
          ... on Product {
            title
            id
            priceRange {
              minVariantPrice {
                amount
              }
            }
            variants(first: 100) {
              edges {
                node {
                  selectedOptions {
                    name
                    value
                  }
                  priceV2 {
                    amount
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  oosMessage: metafield(namespace: "availability", key: "oos_message") {
    key
    value
  }
  yotpoRating: metafield(namespace: "yotpo", key: "reviews_average") {
    key
    value
  }
  variants(first: 100) {
    edges {
      node {
        id
        title
        sku
        availableForSale
        quantityAvailable
        selectedOptions {
          name
          value
        }
        priceV2 {
          amount
        }
        compareAtPriceV2 {
          amount
        }
        oosMessage: metafield(namespace: "availability", key: "oos_message") {
          key
          value
        }
        preorder: metafield(namespace: "availability", key: "preorder") {
          key
          value
        }
        inventoryReno: metafield(namespace: "inventory", key: "reno") {
          value
        }
        inventoryAtlanta: metafield(namespace: "inventory", key: "atlanta") {
          value
        }
        group: metafield(namespace: "custom", key: "group") {
          value
        }
        image {
          src
          altText
          height
          width
          url
        }
        sellingPlanAllocations(first: 1, reverse: true) {
          edges {
            node {
              sellingPlan {
                description
                id
                name
                options {
                  name
                  value
                }
              }
            }
          }
        }
        capacityIcon: metafield(namespace: "custom", key: "capacity_icon") {
          reference {
            ... on MediaImage {
              image {
                altText
                url
              }
            }
          }
        }
        variantAliases: metafield(namespace: "custom", key: "aliases") {
          reference {
            ... on Metaobject {
              id
              aliases: field(key: "aliases") {
                value
              }
              instructions: field(key: "instructions") {
                value
              }
            }
          }
        }
        compatibleSizes: metafield(namespace: "bundle", key: "compatible_sizes") {
          reference {
            ... on Metaobject {
              id
              models: field(key: "models") {
                value
              }
              sizes: field(key: "sizes") {
                value
              }
            }
          }
        }
      }
    }
  }
`;

export const product = `
  ${productFields}
  nonOpenBoxProduct: metafield(namespace: "custom", key: "non_open_box_product") {
    reference {
      ... on Product {
        ${productFields}
      }
    }
  }

`;

export const variant = `
  id
  title
  sku
  availableForSale
  quantityAvailable
  selectedOptions {
    name
    value
  }
  priceV2 {
    amount
  }
  compareAtPriceV2 {
    amount
  }
  oosMessage: metafield(namespace: "availability", key: "oos_message") {
    key
    value
  }
  preorder: metafield(namespace: "availability", key: "preorder") {
    key
    value
  }
  inventoryReno: metafield(namespace: "inventory", key: "reno") {
    value
  }
  inventoryAtlanta: metafield(namespace: "inventory", key: "atlanta") {
    value
  }
  group: metafield(namespace: "custom", key: "group") {
    value
  }
  product {
    title
  }
  image {
    src
    altText
    height
    width
  }
  sellingPlanAllocations(first: 1, reverse: true) {
    edges {
      node {
        sellingPlan {
          description
          id
          name
          options {
            name
            value
          }
        }
      }
    }
  }
  capacityIcon: metafield(namespace: "custom", key: "capacity_icon") {
    reference {
      ... on MediaImage {
        image {
          altText
          url
        }
      }
    }
  }
`;

export const article = `
  id
  onlineStoreUrl
  title
  tags
  excerpt
  handle
  image {
    altText
    url
  }
  blogPostImage: metafield(namespace: "custom", key: "blog_post_image") {
    reference {
      ... on MediaImage {
      presentation {
        asJson(format: IMAGE)
      }
        image {
          altText
          url
        }
      }
    }
  }
  hideFromListing: metafield(namespace: "custom", key: "hide_from_listing") {
    value
  }
  readTime: metafield(namespace: "custom", key: "read_time") {
    value
  }
  videoPost: metafield(namespace: "custom", key: "video_post") {
    value
  }
  videoMobile: metafield(namespace: "custom", key: "hero_video_mobile") {
    reference {
      ... on Video {
        id
        sources {
          height
          width
          mimeType
          format
          url
        }
        previewImage {
          url
          altText
        }
      }
    }
  }
  video: metafield(namespace: "custom", key: "hero_video") {
    reference {
      ... on Video {
        id
        sources {
          height
          width
          mimeType
          format
          url
        }
        previewImage {
          url
          altText
        }
      }
    }
  }
  horizontalImage: metafield(namespace: "custom", key: "featured_image_horizontal") {
    reference {
      ... on MediaImage {
        presentation {
          asJson(format: IMAGE)
        }
        image {
          altText
          url
        }
      }
    }
  }
`;
